import { grey, green } from '@material-ui/core/colors';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginLeft:15,
    marginRight:15,
    // marginTop: -15
  },
  headingTitle: {
    width:80,
    fontSize: 16,
    color: green[900],
    margin:5,
    fontWeight:600
  },
  headingCount: {
    fontSize: 14,
    margin:5,
    marginLeft: 15,
  },
  panelRoot:{
    backgroundColor: grey[50]
  },
  content:{
    display:"block",
    maxHeight:400,
    overflowY:'scroll'
  },
  noNewItem:{
    textAlign: "center",
    fontSize: 16,
  },
  loader: {
    margin: "0px 15px 20px 15px"
  }
});

export default styles;